module.exports = __webpack_public_path__ + "img/BounCA-logo.b0e227e1.png";